import React, {Component, Fragment} from 'react';

import Modals from '../Modals';
import Footer from "../Footer";
import { setDeviceType, setWindowWidth, setPageBreakpoint } from '../../actions/utils';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import withWindowSizes from "../withWindowSizes";
import Header from "../Header";
import HeaderMobile from "../HeaderMobile";
import {getDocuments} from "../../actions/documents";
import SupportChatWidget from "../SupportChatWidget";

class Layout extends Component {

    componentDidMount() {
        this.props.getDocuments();
    }

    componentDidUpdate = (prevProps) => {
        const { windowWidth, pageBreakpoint, setWindowWidth, setPageBreakpoint } = this.props;

        if (prevProps.windowWidth !== windowWidth) {
            setWindowWidth(windowWidth);
        }

        if (prevProps.pageBreakpoint !== pageBreakpoint) {
            setPageBreakpoint(pageBreakpoint);
        }
    };

    render() {

        const {
            children,
            pageBreakpoint
        } = this.props;

        return(
            <Fragment>
                {pageBreakpoint === 'desktop' ? (
                    <Header/>
                ) : (
                    <HeaderMobile/>
                )}
                {/*<FeedbackBlock />*/}
                <main className="site-content">{children}</main>
                <Footer />
                <Modals />
                <SupportChatWidget />
            </Fragment>
        )
    }
}

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setDeviceType,
            setWindowWidth,
            setPageBreakpoint,
            getDocuments,
        },
        dispatch
    );

/* --- */
export default connect(null, mapDispatchToProps)(withRouter(withWindowSizes(Layout)));